export default "__VITE_ASSET__B0NoRc0c__"